import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgReply = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.799 3.775a.75.75 0 0 1 .451.687v3.276c6.397.438 10.566 6.458 9.997 12.792a.75.75 0 0 1-1.431.24c-1.668-3.712-4.75-6.12-8.566-6.091V18a.75.75 0 0 1-1.243.565l-7.5-6.537a.75.75 0 0 1-.019-1.114l7.5-7a.75.75 0 0 1 .81-.14m-6.68 7.668 5.631 4.908v-2.389c0-.39.3-.715.688-.747 3.852-.318 7.063 1.445 9.216 4.325-.753-4.644-4.353-8.328-9.154-8.328a.75.75 0 0 1-.75-.75V6.188z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgReply;
